import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
// Before anything renders: i18next has to be initialised and `<html dir>` set,
// or the first paint is LTR and flips underneath the reader.
import './i18n';
import { App } from './App';
import { SessionProvider } from './auth/session';
import { announceWrite } from './api/announce';
import { setWriteObserver } from './api/client';
import { ToastHost } from './ui/ToastHost';

// Every write the API client makes reports how it went; the toast host shows it.
setWriteObserver(announceWrite);

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
          <ToastHost />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
